import React from "react";
import {List} from "antd";
import StyledContainer from "./CompanyLicenceList.style";
import DeleteTwoTone from "@ant-design/icons/es/icons/DeleteTwoTone";
import DeleteOutlined from "@ant-design/icons/es/icons/DeleteOutlined";
import GridActionIcon from "../../../../components/GridActionIcon";
import {DATE_FORMAT} from "../../../../constants/dateFormat";

const CompanyLicenceList = ({companyLicences, darkMode, removeLicenceElement, primaryColor}) => {

    return <StyledContainer darkMode={darkMode}>
        <List
            size="small"
            footer={<div>Total items: {companyLicences.length}</div>}
            bordered
            dataSource={companyLicences}
            renderItem={({softwareProductElement, quantity, expiryLicenceAction, expiryDate, softwareProductElements}) =>
                <List.Item key={softwareProductElement}>
                    {softwareProductElement}({quantity}) Expiry action
                    - {expiryLicenceAction} on {expiryDate.format(DATE_FORMAT)}

                    <GridActionIcon key="remove"
                                    title='Remove'
                                    disabled={false}
                                    icon={<DeleteTwoTone twoToneColor={primaryColor}/>}
                                    darkIcon={<DeleteOutlined/>}
                                    onClick={() => removeLicenceElement({softwareProductElements})}/>
                </List.Item>}
        />
    </StyledContainer>
};

export default CompanyLicenceList;